/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { APIKey } from '../models/APIKey';
import type { BucketFile } from '../models/BucketFile';
import type { BucketFileDownload } from '../models/BucketFileDownload';
import type { BucketFileUpload } from '../models/BucketFileUpload';
import type { Data } from '../models/Data';
import type { Device } from '../models/Device';
import type { DeviceTelemetry } from '../models/DeviceTelemetry';
import type { GeocodeResult } from '../models/GeocodeResult';
import type { GoogleProfile } from '../models/GoogleProfile';
import type { License } from '../models/License';
import type { LogoutRedirect } from '../models/LogoutRedirect';
import type { Order } from '../models/Order';
import type { OrderActivation } from '../models/OrderActivation';
import type { Principal } from '../models/Principal';
import type { PrincipalGoogleAccount } from '../models/PrincipalGoogleAccount';
import type { Theme } from '../models/Theme';
import type { Version } from '../models/Version';
import type { VersionDownload } from '../models/VersionDownload';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DefaultService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Clear web session data
     * @returns LogoutRedirect Follow returned URL for browser logout
     * @throws ApiError
     */
    public logoutWebSession(): CancelablePromise<LogoutRedirect> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth0/logout',
            errors: {
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new device
     * @param requestBody
     * @returns Device Device created successfully
     * @throws ApiError
     */
    public createDevice(
        requestBody: Device,
    ): CancelablePromise<Device> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/device',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update device
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateDevice(
        requestBody: Device,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/device',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of devices
     * @param limit Number of devices to return
     * @param offset Offset for paginated results
     * @returns Device List of devices retrieved successfully
     * @throws ApiError
     */
    public listDevices(
        limit: number,
        offset: number,
    ): CancelablePromise<Array<Device>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/device',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a device by ID
     * @param id ID of the device to retrieve
     * @returns Device Device retrieved successfully
     * @throws ApiError
     */
    public getDeviceById(
        id: string,
    ): CancelablePromise<Device> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/device/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new API key
     * @param requestBody
     * @returns APIKey APIKey created successfully
     * @throws ApiError
     */
    public createApiKey(
        requestBody: APIKey,
    ): CancelablePromise<APIKey> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/apikey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of API keys
     * @param limit Number of API keys to return
     * @param offset Offset for paginated results
     * @returns APIKey List of API keys retrieved successfully
     * @throws ApiError
     */
    public listApiKeys(
        limit: number,
        offset: number,
    ): CancelablePromise<Array<APIKey>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/apikey',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a API key by ID
     * @param id ID of the API key to retrieve
     * @returns APIKey API key retrieved successfully
     * @throws ApiError
     */
    public getApiKeyById(
        id: string,
    ): CancelablePromise<APIKey> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/apikey/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new license
     * @param requestBody
     * @returns License License created successfully
     * @throws ApiError
     */
    public createLicense(
        requestBody: License,
    ): CancelablePromise<License> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/license',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a new license
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateLicense(
        requestBody: License,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/license',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of licenses
     * @param limit Number of licenses to return
     * @param offset Offset for paginated results
     * @returns License List of licenses retrieved successfully
     * @throws ApiError
     */
    public listLicenses(
        limit: number,
        offset: number,
    ): CancelablePromise<Array<License>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/license',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a license by ID
     * @param id ID of the license to retrieve
     * @returns License License retrieved successfully
     * @throws ApiError
     */
    public getLicenseById(
        id: string,
    ): CancelablePromise<License> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/license/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new principal
     * @param requestBody
     * @returns Principal Principal created successfully
     * @throws ApiError
     */
    public createPrincipal(
        requestBody: Principal,
    ): CancelablePromise<Principal> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/principal',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a new principal
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updatePrincipal(
        requestBody: Principal,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/principal',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of principals
     * @param limit Number of principals to return
     * @param offset Offset for paginated results
     * @returns Principal List of principals retrieved successfully
     * @throws ApiError
     */
    public listPrincipals(
        limit: number,
        offset: number,
    ): CancelablePromise<Array<Principal>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/principal',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a principal by ID
     * @param id ID of the principal to retrieve
     * @returns Principal Principal retrieved successfully
     * @throws ApiError
     */
    public getPrincipalById(
        id: string,
    ): CancelablePromise<Principal> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/principal/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a principal by ID
     * @param id ID of the principal to delete
     * @returns void
     * @throws ApiError
     */
    public deletePrincipalById(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/principal/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get the current principal
     * @returns Principal Current principal retrieved successfully
     * @throws ApiError
     */
    public getCurrentPrincipal(): CancelablePromise<Principal> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/principal/me',
            errors: {
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new version
     * @param requestBody
     * @returns Version Version created successfully
     * @throws ApiError
     */
    public createVersion(
        requestBody: Version,
    ): CancelablePromise<Version> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/version',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of versions
     * @param limit Number of versions to return
     * @param offset Offset for paginated results
     * @returns Version List of versions retrieved successfully
     * @throws ApiError
     */
    public listVersions(
        limit: number,
        offset: number,
    ): CancelablePromise<Array<Version>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/version',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a version by ID
     * @param id ID of the version to retrieve
     * @returns Version Version retrieved successfully
     * @throws ApiError
     */
    public getVersionById(
        id: string,
    ): CancelablePromise<Version> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/version/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a version download by ID
     * @param id ID of the version to retrieve
     * @returns VersionDownload Version download retrieved successfully
     * @throws ApiError
     */
    public getVersionDownloadById(
        id: string,
    ): CancelablePromise<VersionDownload> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/version/{id}/download',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get latest versions
     * @param product Version product
     * @param stream Version stream
     * @param includeNonLiveVersions Include non-live versions
     * @returns Version List of versions retrieved successfully
     * @throws ApiError
     */
    public listLatestVersions(
        product: string,
        stream: string,
        includeNonLiveVersions?: boolean,
    ): CancelablePromise<Array<Version>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/version/latest/{product}/{stream}',
            path: {
                'product': product,
                'stream': stream,
            },
            query: {
                'include_non_live_versions': includeNonLiveVersions,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new principal google account
     * @param requestBody
     * @returns PrincipalGoogleAccount Principal google account created successfully
     * @throws ApiError
     */
    public createPrincipalGoogleAccount(
        requestBody: PrincipalGoogleAccount,
    ): CancelablePromise<PrincipalGoogleAccount> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/googleprofile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of principal google accounts
     * @param limit Number of principal google accounts to return
     * @param offset Offset for paginated results
     * @returns PrincipalGoogleAccount List of principal google accounts retrieved successfully
     * @throws ApiError
     */
    public listPrincipalGoogleAccounts(
        limit: number,
        offset: number,
    ): CancelablePromise<Array<PrincipalGoogleAccount>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/googleprofile',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a principal google account by ID
     * @param id ID of the principal google account to retrieve
     * @returns PrincipalGoogleAccount Principal google account retrieved successfully
     * @throws ApiError
     */
    public getPrincipalGoogleAccountById(
        id: string,
    ): CancelablePromise<PrincipalGoogleAccount> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/googleprofile/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get the Google Profile for a principal google account by ID
     * @param id ID of the principal google account to retrieve
     * @returns GoogleProfile Google Profile retrieved successfully
     * @throws ApiError
     */
    public getGoogleProfileByPrincipalGoogleAccountId(
        id: string,
    ): CancelablePromise<GoogleProfile> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/googleprofile/{id}/profile',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a principal google account by ID
     * @param id ID of the principal google account to delete
     * @returns void
     * @throws ApiError
     */
    public deletePrincipalGoogleAccountById(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/googleprofile/{id}/profile',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a principal google account by principal UUID
     * @param principalUuid Principal UUID of the principal google account to retrieve
     * @returns PrincipalGoogleAccount Principal google account retrieved successfully
     * @throws ApiError
     */
    public getPrincipalGoogleAccountByPrincipalUuid(
        principalUuid: string,
    ): CancelablePromise<PrincipalGoogleAccount> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/googleprofile/by-principal-uuid/{principal_uuid}',
            path: {
                'principal_uuid': principalUuid,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get the principal google account for the current user
     * @returns PrincipalGoogleAccount Principal google account retrieved successfully
     * @throws ApiError
     */
    public getMyPrincipalGoogleAccount(): CancelablePromise<PrincipalGoogleAccount> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/googleprofile/me',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete the principal google account for the current user
     * @returns void
     * @throws ApiError
     */
    public deleteMyPrincipalGoogleAccount(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/googleprofile/me',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get the Google Profile for the current user
     * @returns GoogleProfile Google Profile retrieved successfully
     * @throws ApiError
     */
    public getMyGoogleProfile(): CancelablePromise<GoogleProfile> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/googleprofile/me/profile',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get the Google OAuth URL for the current user
     * @returns any Google OAuth URL retrieved successfully
     * @throws ApiError
     */
    public getMyGoogleAuthUrl(): CancelablePromise<{
        url?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/googleprofile/me/auth-url',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Google OAuth2 callback endpoint
     * @param code Google OAuth2 code
     * @param state Google OAuth2 state
     * @returns void
     * @throws ApiError
     */
    public googleOAuth2Callback(
        code: string,
        state: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/googleprofile/me/oauth2-callback',
            query: {
                'code': code,
                'state': state,
            },
            errors: {
                307: `Redirect to the frontend`,
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get data for the given device UUID
     * @param deviceUuid Device UUID
     * @param dataVersion Data version
     * @returns Data Data retrieved successfully
     * @throws ApiError
     */
    public getDataByDeviceUuid(
        deviceUuid: string,
        dataVersion?: string,
    ): CancelablePromise<Data> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data/{device_uuid}',
            path: {
                'device_uuid': deviceUuid,
            },
            query: {
                'data_version': dataVersion,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of orders
     * @param limit Number of orders to return
     * @param offset Offset for paginated results
     * @returns Order List of orders retrieved successfully
     * @throws ApiError
     */
    public listOrders(
        limit: number,
        offset: number,
    ): CancelablePromise<Array<Order>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/order',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new order
     * @param requestBody
     * @returns Order Order created successfully
     * @throws ApiError
     */
    public createOrder(
        requestBody: Order,
    ): CancelablePromise<Order> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/order',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an order
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateOrder(
        requestBody: Order,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/order',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get an order by UUID
     * @param uuid UUID of the order to retrieve
     * @returns Order Order retrieved successfully
     * @throws ApiError
     */
    public getOrderByUuid(
        uuid: string,
    ): CancelablePromise<Order> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/order/{uuid}',
            path: {
                'uuid': uuid,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Activate an order
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public activateOrder(
        requestBody: OrderActivation,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/order/activate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Geocode a location
     * @param lat
     * @param lng
     * @param term
     * @returns GeocodeResult Successful operation
     * @throws ApiError
     */
    public geocode(
        lat: string,
        lng: string,
        term: string,
    ): CancelablePromise<GeocodeResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/world/geocode',
            query: {
                'lat': lat,
                'lng': lng,
                'term': term,
            },
            errors: {
                400: `Invalid input`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new theme
     * @param requestBody
     * @returns Theme Theme created successfully
     * @throws ApiError
     */
    public createTheme(
        requestBody: Theme,
    ): CancelablePromise<Theme> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/theme',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a theme
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateTheme(
        requestBody: Theme,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/theme',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of themes
     * @param limit Number of themes to return
     * @param offset Offset for paginated results (optional)
     * @returns Theme List of themes retrieved successfully
     * @throws ApiError
     */
    public listThemes(
        limit: number,
        offset: number,
    ): CancelablePromise<Array<Theme>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/theme',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Apply a preset theme
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public applyPresetTheme(
        requestBody: {
            preset_name: string;
            theme_uuid: string;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/theme/preset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Apply layout defaults for physical parameters
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public applyThemePhysicalLayoutDefaults(
        requestBody: {
            theme_uuid: string;
            width: number;
            height: number;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/theme/physical',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a theme by ID
     * @param id ID of the theme to retrieve
     * @returns Theme Theme retrieved successfully
     * @throws ApiError
     */
    public getThemeById(
        id: string,
    ): CancelablePromise<Theme> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/theme/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request - Invalid input`,
                401: `Unauthorized - Invalid or missing access token`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * @param offset
     * @param limit
     * @param tag
     * @returns BucketFile Successful operation
     * @throws ApiError
     */
    public listBucketFiles(
        offset: number,
        limit: number,
        tag: string,
    ): CancelablePromise<BucketFile> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bucketfile',
            query: {
                'offset': offset,
                'limit': limit,
                'tag': tag,
            },
        });
    }

    /**
     * @param requestBody
     * @returns BucketFile Success
     * @throws ApiError
     */
    public createBucketFile(
        requestBody: BucketFile,
    ): CancelablePromise<BucketFile> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/bucketfile',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param uuid
     * @returns BucketFile Successful operation
     * @throws ApiError
     */
    public getBucketFileById(
        uuid: string,
    ): CancelablePromise<BucketFile> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bucketfile/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param uuid
     * @returns void
     * @throws ApiError
     */
    public deleteBucketFileById(
        uuid: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/bucketfile/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param uuid
     * @returns BucketFileDownload Successful operation
     * @throws ApiError
     */
    public getBucketFileDownload(
        uuid: string,
    ): CancelablePromise<BucketFileDownload> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bucketfile/{uuid}/download',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param uuid
     * @returns BucketFileUpload Successful operation
     * @throws ApiError
     */
    public getBucketFileUpload(
        uuid: string,
    ): CancelablePromise<BucketFileUpload> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bucketfile/{uuid}/upload',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param uuid
     * @returns void
     * @throws ApiError
     */
    public markBucketFileUploadComplete(
        uuid: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/bucketfile/{uuid}/upload/complete',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public createDeviceTelemetry(
        requestBody: DeviceTelemetry,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/telemetry/device',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

}
